/**
 * JSONP Interceptor.
 */

module.exports = function (_) {

    var jsonpClient = require('../client/jsonp')(_);

    return {

        request: function (request) {

            if (request.method == 'JSONP') {
                request.client = jsonpClient;
            }

            return request;
        }

    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/interceptor/jsonp.js
// module id = 225
// module chunks = 1